import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { StyledDialog, CustomErrorMessage, ErrorLoginButton } from './styles'

const LoginDialog = (props) => {
  return (
    <StyledDialog open={props.error || props.status === 'failure'} onClose={props.onCloseError}>
      <CustomErrorMessage className="error">
        <Grid container>
          <Grid item xs={10}>
            {props.errorText}
            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{ __html: props.loginError }}
            />
          </Grid>
          <Grid item xs={2}>
            <ErrorLoginButton onClick={() => props.onCloseError()}>Close</ErrorLoginButton>
          </Grid>
        </Grid>
      </CustomErrorMessage>
    </StyledDialog>
  )
}

export default LoginDialog
